/*
 * @Author: xianghongai@gmail.com
 * @Date: 2017-11-09 15:53:26
 * @Last Modified by: Nicholas Hsiang
 * @Last Modified time: 2017-12-05 18:52:07
 */


// bug feedback: xianghongai@gmail.com
var hs = hs || {};

/*
 * var myValidation=new hs.Validation()
 * 默认检验：手机/密码/确认密码/用户名/姓名/邮箱
 * myValidation.init();
 * 单个验证myValidation.idcardInit('.j_input_idcard');
 */


// 这里仅客户端初步检验, 后端不要在这里写代码
// TODO: msgType应该有多种状态，如错误提示/警告提示/正常提示
hs.Validation = function(param) {
    param = param || {};

    this.formEle = param.formEle || '.module-form';

    this.msg = {
        phone: "请输入正确的手机号",
        sms: "验证码不正确",
        password: "密码由6到20位数字和字母组合",
        passwordConfirm: "密码不一致",
        username: "名字不正确",
        nickname: "昵称由2到12位中英文数字-_字符组成",
        idcard: "身份证号格式错误",
        email: "邮件地址不正确",
        qq: "QQ号码不正确",
        weixin: "微信号不正确",
        captcha: "检验码不正确",
        companyname: "单位名不正确"
    };

    this.msgType = {
        phone: "error",
        sms: "error",
        password: "error",
        passwordConfirm: "error",
        username: "error",
        nickname: "error",
        idcard: "error",
        email: "error",
        qq: "error",
        weixin: "error",
        captcha: "error",
        companyname: "error"
    };

    this.pass = {
        phone: false,
        sms: false,
        password: false,
        passwordConfirm: false,
        username: false,
        nickname: false,
        idcard: false,
        email: false,
        qq: false,
        weixin: false,
        captcha: false,
        companyname: false
    };
};

hs.Validation.prototype.i18n = {

};

//#region 检验操作
// 添加检验提示信息，msgType: error/info
hs.Validation.prototype._trim = function(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
};

hs.Validation.prototype.addNotify = function($item, msg, msgType) {
    $item.parents(".form-wrapper").find(".form-verify-message").detach();
    $item.after('<span class="form-verify-message has-' + msgType + '"><i class="iconfont icon-' + msgType + '"></i>' + msg + '</span>');
};

// 移除检验提示信息，根据检验对象"$item"找特定的对象".form-verify-message"
hs.Validation.prototype.removeNotify = function($item) {
    $item.parents(".form-wrapper").find(".form-verify-message").detach();
};

// 检验，$item 检验对象，verify 检验函数
hs.Validation.prototype._verify = function($item, verify) {
    var itemVal = $.trim($item.val());
    if (itemVal === "") {
        return false;
    }
    return verify(itemVal);
};

// 检验结果提示（检验是否通过，$item 检验对象，msg string 提示信息，msgType 信息分类 error/info）
hs.Validation.prototype._verifyNotify = function(param) {
    var _this = this;
    var val = param.$item.val();
    if (val) {
        if (!param.pass) {
            _this.addNotify(param.$item, param.msg, param.msgType);
        } else {
            _this.removeNotify(param.$item);
        }
    } else {
        // 没有进行任何操作恢复到默认状态
        _this.removeNotify(param.$item);
    }
};
//#endregion

//#region 检验对外方法接口

// 检验手机号码
hs.Validation.prototype.verifyPhone = function($item) {
    var _this = this;

    function verify(val) {
        return /^1(3|4|5|7|8)\d{9}$/.test(val);
    }
    // 检验
    _this.pass.phone = _this._verify($item, verify);
    // 检验结果提示
    _this._verifyNotify({
        $item: $item,
        pass: _this.pass.phone,
        msg: _this.msg.phone,
        msgType: _this.msgType.phone
    });

    return this.pass.phone;
};

// 检验字母数字图形验证码
hs.Validation.prototype.verifyCaptcha = function($item) {
    var _this = this;

    function verify(val) {
        return /^[a-zA-Z0-9]{4,6}$/.test(val);
    }
    // 执行检验
    _this.pass.captcha = _this._verify($item, verify);
    // 执行检验提示
    _this._verifyNotify({
        $item: $item,
        pass: _this.pass.captcha,
        msg: _this.msg.captcha,
        msgType: _this.msgType.captcha
    });

    return _this.pass.captcha;
};

// 检验短信验证码4-6/6位
hs.Validation.prototype.verifySMS = function($item) {
    var _this = this;

    function verify(val) {
        return /^[0-9]{4,6}$/.test(val);
    }
    // 执行检验
    _this.pass.sms = _this._verify($item, verify);
    // 执行检验提示
    _this._verifyNotify({
        $item: $item,
        pass: _this.pass.sms,
        msg: _this.msg.sms,
        msgType: _this.msgType.sms
    });

    return _this.pass.sms;
};
hs.Validation.prototype.verifySMS6 = function($item) {
    var _this = this;

    function verify(val) {
        return /^[0-9]{6}$/.test(val);
    }
    // 执行检验
    _this.pass.sms = _this._verify($item, verify);
    // 执行检验提示
    _this._verifyNotify({
        $item: $item,
        pass: _this.pass.sms,
        msg: _this.msg.sms,
        msgType: _this.msgType.sms
    });

    return _this.pass.sms;
};

// 检验昵称
hs.Validation.prototype.verifyNickName = function($item) {
    var _this = this;

    function verify(val) {
        if (val.length < 2) {
            _this.msg.nickname = "昵称太短";
            return false;
        } else if (val.length > 20) {
            _this.msg.nickname = "昵称太长";
            return false;
        } else if (/^\d+$/g.test(val)) {
            _this.msg.nickname = "昵称不能全是数字";
            return false;
        } else if (!/^(?![_\-])(?!.*?[_\-]$)/.test(val)) {
            _this.msg.nickname = "昵称不能以'_'或'-'开头结尾";
            return false;
        } else if (!/^[a-zA-Z0-9_\-\u4e00-\u9fa5]+$/.test(val)) {
            _this.msg.nickname = "昵称由2到12位中英文数字-_字符组成";
            return false;
        }
        return true;
    }
    // 执行检验
    _this.pass.nickname = _this._verify($item, verify);
    // 执行检验提示
    _this._verifyNotify({
        $item: $item,
        pass: _this.pass.nickname,
        msg: _this.msg.nickname,
        msgType: _this.msgType.nickname
    });
    return _this.pass.nickname;
};

// 检验密码
hs.Validation.prototype.verifyPassword = function($item) {
    var _this = this;

    function verify(val) {
        if (val.length < 6) {
            _this.msg.password = "密码位数太少，至少6位";
            return false;
        } else if (val.length > 20) {
            _this.msg.password = "密码位数太多，最多20位";
            return false;
        } else if (val.search(/\d/) === -1) {
            _this.msg.password = "未包含数字";
            return false;
        } else if (/^\d+$/g.test(val)) {
            _this.msg.password = "密码不能全是数字";
            return false;
        } else if (!/^(?=.*\d)(?=.*[a-zA-Z!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{6,20}$/.test(val)) {
            _this.msg.password = "密码由6到20位数字和字母组合";
            return false;
        }
        return true;
    }
    // 执行检验
    _this.pass.password = _this._verify($item, verify);
    // 执行检验提示
    _this._verifyNotify({
        $item: $item,
        pass: _this.pass.password,
        msg: _this.msg.password,
        msgType: _this.msgType.password
    });
    return _this.pass.password;
};

// 检验确认密码
hs.Validation.prototype.verifyPasswordConfirm = function($itemOrigin, $itemConfirm) {
    var _this = this;

    function verify(valOrigin, valConfirm) {
        if (valOrigin !== valConfirm) {
            _this.msg.passwordConfirm = "密码不一致";
            return false;
        }
        return true;
    }
    // 执行检验
    _this.pass.passwordConfirm = verify($itemOrigin.val(), $itemConfirm.val());
    // 执行检验提示
    _this._verifyNotify({
        $item: $itemConfirm,
        pass: _this.pass.passwordConfirm,
        msg: _this.msg.passwordConfirm,
        msgType: _this.msgType.passwordConfirm
    });
    return _this.pass.passwordConfirm;
};

// 检验姓名
hs.Validation.prototype.verifyUserName = function($item) {
    var _this = this;

    function verify(val) {
        return /^[a-zA-Z0-9.\u4e00-\u9fa5]{2,20}$/.test(val);
    }
    // 执行检验
    _this.pass.username = _this._verify($item, verify);
    // 执行检验提示
    _this._verifyNotify({
        $item: $item,
        pass: _this.pass.username,
        msg: _this.msg.username,
        msgType: _this.msgType.username
    });

    return _this.pass.username;
};
// 检验公司名
hs.Validation.prototype.verifyCompanyName = function($item) {
    var _this = this;

    function verify(val) {
        return /^[a-zA-Z0-9.\u4e00-\u9fa5]{2,20}$/.test(val);
    }
    // 执行检验
    _this.pass.companyname = _this._verify($item, verify);
    // 执行检验提示
    _this._verifyNotify({
        $item: $item,
        pass: _this.pass.companyname,
        msg: _this.msg.companyname,
        msgType: _this.msgType.companyname
    });

    return _this.pass.companyname;
};
// 验证身份证
hs.Validation.prototype.verifyIDCode = function($item) {
    var _this = this;

    function verify(code) {
        var city = {
            11: "北京",
            12: "天津",
            13: "河北",
            14: "山西",
            15: "内蒙古",
            21: "辽宁",
            22: "吉林",
            23: "黑龙江 ",
            31: "上海",
            32: "江苏",
            33: "浙江",
            34: "安徽",
            35: "福建",
            36: "江西",
            37: "山东",
            41: "河南",
            42: "湖北 ",
            43: "湖南",
            44: "广东",
            45: "广西",
            46: "海南",
            50: "重庆",
            51: "四川",
            52: "贵州",
            53: "云南",
            54: "西藏 ",
            61: "陕西",
            62: "甘肃",
            63: "青海",
            64: "宁夏",
            65: "新疆",
            71: "台湾",
            81: "香港",
            82: "澳门",
            91: "国外 "
        };
        if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
            _this.msg.idcard = "身份证号格式错误";
            return false;
        } else if (!city[code.substr(0, 2)]) {
            _this.msg.idcard = "身份证号地址编码错误";
            return false;
        } else {
            //18位身份证需要验证最后一位校验位
            if (code.length === 18) {
                code = code.split('');
                //∑(ai×Wi)(mod 11)
                //加权因子
                var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
                //校验位
                var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
                var sum = 0;
                var ai = 0;
                var wi = 0;
                for (var i = 0; i < 17; i++) {
                    ai = code[i];
                    wi = factor[i];
                    sum += ai * wi;
                }
                if (parity[sum % 11].toString() !== code[17].toUpperCase()) {
                    _this.msg.idcard = "身份证有误，请检查后重新输入";
                    return false;
                }
            }
        }
        return true;
    }
    // 执行检验
    _this.pass.idcard = _this._verify($item, verify);
    // 执行检验提示
    _this._verifyNotify({
        $item: $item,
        pass: _this.pass.idcard,
        msg: _this.msg.idcard,
        msgType: _this.msgType.idcard
    });

    return _this.pass.idcard;
};

// 检验邮箱
hs.Validation.prototype.verifyEmail = function($item) {
    var _this = this;

    function verify(val) {
        return /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/.test(val);
    }
    // 执行检验
    _this.pass.email = _this._verify($item, verify);
    // 执行检验提示
    _this._verifyNotify({
        $item: $item,
        pass: _this.pass.email,
        msg: _this.msg.email,
        msgType: _this.msgType.email
    });

    return _this.pass.email;
};

// 检验QQ
hs.Validation.prototype.verifyQQ = function($item) {
    var _this = this;

    function verify(val) {
        return /[1-9][0-9]{4,}/.test(val);
    }
    // 执行检验
    _this.pass.qq = _this._verify($item, verify);
    // 执行检验提示
    _this._verifyNotify({
        $item: $item,
        pass: _this.pass.qq,
        msg: _this.msg.qq,
        msgType: _this.msgType.qq
    });

    return _this.pass.qq;
};

// 检验微信(目前微信号不支持设置为中文帐号，是以字母开头的帐号（可以使用6—20个字母、数字、下划线和减号，必须以字母开头。）)
hs.Validation.prototype.verifyWeiXin = function($item) {
    var _this = this;

    function verify(val) {
        return /^[a-zA-Z]{1}[-_a-zA-Z0-9]{5,19}$/.test(val);
    }
    // 执行检验
    _this.pass.weixin = _this._verify($item, verify);
    // 执行检验提示
    _this._verifyNotify({
        $item: $item,
        pass: _this.pass.weixin,
        msg: _this.msg.weixin,
        msgType: _this.msgType.weixin
    });

    return _this.pass.weixin;
};
//#endregion

//#region 页面初始校验接口

// 手机号
hs.Validation.prototype.phoneInit = function(item) {
    var _this = this;
    var $item = $(item);
    // 输入框失去焦点时验证
    $item.on("blur", function() {
        _this.verifyPhone($(this));
    });

    // 输入实时触发检验
    $item.keyup(function() {
        var $this = $(this);
        var $parent = $this.parents('.module-form');
        var $verifyMessage = $parent.find(".get-sms");
        var itemVal = $.trim($this.val());

        if ($verifyMessage) {
            if (itemVal.length === 11 && _this.verifyPhone($this) && !$verifyMessage.hasClass('get-sms-doing')) {
                _this.removeNotify($this);
                $verifyMessage.removeClass("get-sms-disabled");
            } else {
                if (!$verifyMessage.hasClass("get-sms-disabled")) {
                    $verifyMessage.addClass("get-sms-disabled");
                }
            }
        }
    });

};

// 昵称
hs.Validation.prototype.nicknameInit = function(item) {
    var _this = this;
    $(item).on("blur", function() {
        _this.verifyNickName($(this));
    });
};

// 字母数字图形验证码
hs.Validation.prototype.captchaInit = function(item) {
    var _this = this;
    $(item).on("blur", function() {
        _this.verifyCaptcha($(this));
    });
};

// 短信
hs.Validation.prototype.smsInit = function(item) {
    var _this = this;
    $(item).on("blur", function() {
        _this.verifySMS($(this));
    });
};

// 短信
hs.Validation.prototype.sms6Init = function(item) {
    var _this = this;
    $(item).on("blur", function() {
        _this.verifySMS6($(this));
    });
};

// 密码
hs.Validation.prototype.passwordInit = function(item) {
    var _this = this;
    var $item = $(item);
    $item.on("blur", function() {
        _this.verifyPassword($(this));
    });
    // 过滤空格
    $item.on("keydown", function(evt) {
        var keycode = evt.charCode || evt.keyCode;
        if (keycode === 32) {
            evt.keyCode = 0;
            return false;
        }
    });
};

// 检验确认密码
hs.Validation.prototype.passworConfirmdInit = function(itemOrigin, itemConfirm) {
    var _this = this;

    $(itemConfirm).on("blur", function() {
        _this.verifyPassword($(itemOrigin));

        _this.verifyPasswordConfirm($(itemOrigin), $(this));
    });
};

// 名字
hs.Validation.prototype.userNameInit = function(item) {
    var _this = this;
    $(item).on("blur", function() {
        _this.verifyUserName($(this));
    });
};
// 公司名字
hs.Validation.prototype.companyNameInit = function(item) {
    var _this = this;
    $(item).on("blur", function() {
        _this.verifyCompanyName($(this));
    });
};
// 身份证
hs.Validation.prototype.idcardInit = function(item) {
    var _this = this;
    $(item).on("blur", function() {
        _this.verifyIDCode($(this));
    });
};

// 邮箱
hs.Validation.prototype.emailInit = function(item) {
    var _this = this;
    $(item).on("blur", function() {
        _this.verifyEmail($(this));
    });
};

// QQ
hs.Validation.prototype.qqInit = function(item) {
    var _this = this;
    $(item).on("blur", function() {
        _this.verifyQQ($(this));
    });
};

// WeiXin
hs.Validation.prototype.weixinInit = function(item) {
    var _this = this;
    $(item).on("blur", function() {
        _this.verifyWeiXin($(this));
    });
};
//#endregion

hs.Validation.prototype.init = function() {
    var _this = this;
    var $formEle = $(_this.formEle);

    var $inputPhone = $formEle.find('.j_input_phone');
    var $inputPassword = $formEle.find('.j_input_password');
    var $inputNickname = $formEle.find('.j_input_nickname');
    var $inputUsername = $formEle.find('.j_input_username');
    var $inputConfirmPassword = $formEle.find('.j_input_confirm_password');
    var $inputEmail = $formEle.find('.j_input_email');
    // 默认检验：手机/密码/确认密码/用户名/姓名/邮箱
    $inputPhone.length && _this.phoneInit('.j_input_phone');
    $inputPassword.length && _this.passwordInit('.j_input_password');
    $inputPassword.length && $inputConfirmPassword.length && _this.passworConfirmdInit('.j_input_password', '.j_input_confirm_password');
    $inputNickname.length && _this.nicknameInit('.j_input_nickname');
    $inputUsername.length && _this.userNameInit('.j_input_username');
    $inputEmail.length && _this.emailInit('.j_input_email');
};